import { BaseMenuItem, LIVE_MANIFESTAZIONE_DETAILS } from '../../types';
import React, { useEffect, useRef } from 'react';

import { AmbienteContext } from 'context/Ambiente';
import { IconsEnum } from 'components/Icons';
import { LiveNavAccordion } from '../liveNavAccordion/LiveNavAccordion';
import LiveNavAccordionScommessa from '../liveNavAccordionScommessa/LiveNavAccordionScommessa';
import { Spinner } from 'components/spinner';
import { doFetch } from 'features/api/thunkUtils';
import { menuApi } from 'features/api/menuApiSlice';
import menuStyle from './liveManifestazioneMenuItem.module.scss';
import styleNavFavouriteMenuItem from '../liveNavFavouriteMenuItem/LiveNavFavouriteMenuItem.module.scss';
import styles from '../../../liveInternalLayout/LiveInternalLayout.module.scss';
import { useAppDispatch } from 'lib/centralStore';
import { useGetLabelByKey } from 'hooks/useLingUI';
import { useManifestazione } from '../../hooks';

export interface ManifestazioneMenuItemProps extends BaseMenuItem {
  idDisciplina: number | string;
}

export const LiveManifestazioneMenuItem = ({ idDisciplina, id }: ManifestazioneMenuItemProps): JSX.Element => {
  const dispatch = useAppDispatch();
  const entryId = `${idDisciplina}-${id}`;
  const scommesseNotAvailable = useGetLabelByKey('menu-scommesse-not-available');

  const { slug, isExpanded, isLoading, descrizione, descrizioneTrKey, scommesse } = useManifestazione(idDisciplina, id);

  const refExpandedStatus = useRef(isExpanded);
  useEffect(() => {
    if (refExpandedStatus.current !== isExpanded) {
      refExpandedStatus.current = isExpanded;

      if (isExpanded) {
        dispatch(
          doFetch({
            id,
            uid: LIVE_MANIFESTAZIONE_DETAILS,
            slug,
            query: menuApi.endpoints.getManifestazioneDetails,
            idDisciplina,
            paramAsObject: true,
          })
        );
      }
    }
  }, [id, slug, idDisciplina, isExpanded, dispatch]);

  const renderScommesse = (): JSX.Element => {
    if (isExpanded) {
      if (isLoading) {
        return <Spinner className={styleNavFavouriteMenuItem.loading} key={`spinner-${entryId}`} />;
      }

      if (scommesse.length === 0) {
        return <span className={menuStyle.scommessaNotAvailable}>{scommesseNotAvailable}</span>;
      }

      return (
        <AmbienteContext.Provider
          key={`content-${entryId}`}
          value={{
            pathScommessa: ['liveNav', 'discipline', `${idDisciplina}`, 'manifestazioni', `${id}`, 'scommesse'],
            ambiente: 'sport',
          }}
        >
          {scommesse
            .filter((x) => !!x)
            .map((scommessa) => (
              <LiveNavAccordionScommessa identifier={scommessa!} key={`${entryId}-${scommessa}`} />
            ))}
        </AmbienteContext.Provider>
      );
    }

    return <React.Fragment key={`content-${entryId}`} />;
  };

  return (
    <LiveNavAccordion
      key={entryId}
      icon={isExpanded ? IconsEnum.MINUS : IconsEnum.PLUS}
      entryId={entryId}
      description={descrizione}
      descriptionTrKey={descrizioneTrKey}
      className={styles.itemManifestazione}
    >
      {renderScommesse()}
    </LiveNavAccordion>
  );
};
